import { render } from "./Defender.vue?vue&type=template&id=bb1d6a8e"
import script from "./Defender.vue?vue&type=script&lang=js"
export * from "./Defender.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/statistics/kingdoms/Defender.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bb1d6a8e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bb1d6a8e', __exports__)) {
    api.reload('bb1d6a8e', __exports__)
  }
  
  module.hot.accept("./Defender.vue?vue&type=template&id=bb1d6a8e", () => {
    api.rerender('bb1d6a8e', render)
  })

}


export default __exports__